import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import ME from "../views/ME";
import Project_Planning from "../views/Project_Planning";
import Research from "../views/Research";
import Outsorcing from "../views/Outsorcing";
import HR_Management from "../views/HR_Management";
import Agriculture from "../views/Agriculture";	
import IT from "../views/IT";	
import ReEngineering from "../views/ReEngineering";	

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'monitoring&evaluation' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ME/>
		} else if(
			appContext.navSubItem === 'project_planning' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Project_Planning/>
		} else if(
			appContext.navSubItem === 'research' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Research/>
		} else if(
			appContext.navSubItem === 'outsorcing' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Outsorcing/>
		} else if(
			appContext.navSubItem === 'HR_management' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <HR_Management/>
		} else if(
			appContext.navSubItem === 'IT' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IT/>
		} else if(
			appContext.navSubItem === 'Re-engineering' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ReEngineering/>
		}else if(
			appContext.navSubItem === 'agriculture' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Agriculture/>
		} 
		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}